import { shallowMount } from "@vue/test-utils";
import SexoSelect from "@/components/core/custom/SexoSelect";

describe("SexoSelect component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(SexoSelect);
  });

  it("Renders del component SexoSelect", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
